import Base from '../../base'

export default class Default extends Base {
  init() {
    if (this.d.template.indexOf('blog-lookbooks') == -1) return
    //Bail unless we are on product page
  }
}
